import axios from 'axios'
import { URIS, loadHeaders } from '../Uris'
import { db } from '../pouchdb'

import { uploadConstants, envConstants } from '../constants'
import { callDetails } from './dashboard.actions'

export function getAllPendingDocs() {
  return (dispatch) => {
    db.allDocs({ include_docs: true }).then((d) => {
      d.rows
        .filter((x) => x.doc.status === envConstants.upload.must_be_sent)
        .forEach((row) => {
          const doc = row.doc
          doc.chunks.forEach((c) => {
            delete c.data
            const data = {
              name: doc.name,
              size: doc.size,
              _id: doc._id,
              ...c
            }
            dispatch(addChunkToQueue({ ...data }))
          })
        })
    })
  }
}

export function addChunkToQueue(payload) {
  return {
    type: uploadConstants.UPLOAD_CHUNK_FILE_TO_QUEUE,
    payload
  }
}

export function addFileToQueue(payload) {
  return {
    type: uploadConstants.UPLOAD_ADD_FILE_TO_QUEUE,
    payload
  }
}

export function startUpload(payload) {
  return (dispatch) => {
    dispatch(uploadingStart())
    const promises = []
    db.get(payload._id).then(async (doc) => {
      doc.chunks.forEach(async (f, index) => {
        const data = {
          name: payload.name.replace('_', '-'),
          chunk_number: index + 1,
          chunk_total: doc.chunks.length,
          upload_group: doc.upload_group,
          groupId: doc.groupId,
          userId: doc.userId,
          data: f.data,
          size: f.size,
          _id: doc._id,
          footprint: doc.footprint
        }
        promises.push(
          new Promise((resolve, reject) => {
            axios({
              method: 'POST',
              url: URIS.photos,
              headers: loadHeaders(),
              data
            })
              .then((res) => {
                delete f.data
                f.status = envConstants.upload.sent
                const data = {
                  name: doc.name,
                  size: doc.size,
                  _id: doc._id,
                  ...f
                }
                dispatch(updateQueue(data))
                resolve(res)
              })
              .catch((error) => {
                reject(error)
              })
          })
        )
      })
      await Promise.all(promises)
      dispatch(endUpload(doc))
      dispatch(callDetails(doc.footprint.holeid))
    })
  }
}

export function endUpload(payload) {
  db.get(payload._id).then((doc) => {
    db.remove(doc)
  })

  return {
    type: uploadConstants.UPLOAD_END_UPLOAD,
    payload
  }
}

function uploadingStart() {
  return {
    type: uploadConstants.UPLOAD_START_UPLOAD
  }
}

function updateQueue(payload) {
  return {
    type: uploadConstants.UPLOAD_UPDATE_QUEUE,
    payload
  }
}

export function uploadProcessing() {
  return {
    type: uploadConstants.UPLOAD_PROCESSING
  }
}

export function uploadEndProcessing() {
  return {
    type: uploadConstants.UPLOAD_END_PROCESSING
  }
}
